import ProductRemoveStore from './ProductRemoveStore'

export default ProductRemoveStore
